import { makeStyles } from '@material-ui/core/styles';
import { TextColors } from '@/utils/constants';

const PriceListStyles = makeStyles(({ spacing, typography }) => ({
  root: {
    position: 'relative',
  },
  titleWrapper: {
    marginBottom: spacing(3),
  },
  description: {
    // margin: spacing(0, 0, 1),
    '& h3': {
      ...typography.subtitle2,
      '&:not(:last-child)': {
        marginBottom: spacing(0.5),
      },
    },
    '& p': {
      ...typography.body2,
    },
  },
  instructions: {
    color: TextColors.light,
    opacity: 0.8,
    fontSize: '16px',
    margin: 0,
  },
  textWrapper: {
    margin: spacing(0, 0, 4),
  },
}));

export default PriceListStyles;
